import React from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'
import brandTheme from '../../Assets/Styles/brandTheme'

const { colors } = brandTheme()

const styles = {
  container: {
    color: '#8A96A0',
    paddingLeft: 10,
    '&:hover': {
      backgroundColor: '#F8F8F8',
    },
    '&>*': {
      verticalAlign: 'middle',
    },
  },
  containerActive: {
    backgroundColor: '#F8F8F8',
    color: colors.secondary,
  },
  iconContainer: {
    height: 48,
    width: 48,
    display: 'inline-block',
    textAlign: 'center',
    lineHeight: '48px',
    '&>*': {
      verticalAlign: 'middle',
    },
    float: 'right',
    fill: '#8A96A0',
  },
  content: {
    display: 'inline-block',
  },
}

const Option = ({ icon, children, active, classes, level, ...otherProps }) => (
  <div
    className={classNames({
      [classes.container]: true,
      [classes.containerActive]: active,
    })}
    style={{
      paddingLeft: level ? (level - 1) * 20 : undefined,
    }}
    {...otherProps}
  >
    <div className={classes.content}>{children}</div>
    <div className={classes.iconContainer}>{icon}</div>
  </div>
)

export default injectStyles(styles)(Option)



// WEBPACK FOOTER //
// ./src/Components/DashboardSidebar/Option.js